import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import HeroSection from './components/HeroSection';
import QuickAccessTiles from './components/QuickAccessTiles';
import FeaturedMotors from './components/FeaturedMotors';
import TestimonialCarousel from './components/TestimonialCarousel';
import PromotionalBanner from './components/PromotionalBanner';
import WhyChooseUs from './components/WhyChooseUs';

const Homepage = () => {
  return (
    <>
      <Helmet>
        <title>Honda Berdikari Pamulang - Dealer Resmi Honda Terpercaya di Tangerang Selatan</title>
        <link rel="icon" href="/assets/logo/logoHonda.webp" />
        <meta 
          name="description" 
          content="Dealer resmi Honda Pamulang menyediakan motor Honda terbaru dengan kredit mudah, service berkualitas, dan layanan purna jual terpercaya di Tangerang Selatan. Dapatkan promo menarik dan konsultasi gratis sekarang!" 
        />
        <meta name="keywords" content="Honda Pamulang, dealer Honda, motor Honda, kredit motor, service motor, Honda Tangerang Selatan" />
        <meta property="og:title" content="Honda Pamulang - Dealer Resmi Honda Terpercaya" />
        <meta property="og:description" content="Wujudkan impian berkendara Anda bersama Honda Pamulang. Dealer resmi dengan layanan terbaik dan kredit mudah." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://hondapamulang.co.id/homepage" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main>
          <HeroSection />
          <QuickAccessTiles />
          <FeaturedMotors />
          <PromotionalBanner />
          <TestimonialCarousel />
          <WhyChooseUs />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default Homepage;